<template>
    <div>
        <template v-if="user">
            <router-link class="user-wrap link" :to="`/users/users/${user.id}/details`"
                         v-if="$user.hasPermission('user-view')">
                <div class="user-inner">
                    <div class="user">
                        <div class="top" v-if="user.user_profile">
                            <slot>{{user.user_profile.name}}</slot>
                        </div>
                        <div class="sub" v-if="user.user_role">{{user.user_role.name}}</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                    <span class="owner-tag" v-if="user.id === $store.state.user.user.id">you</span>
                </div>
            </router-link>
            <div class="user-wrap" v-else>
                <div class="user-inner">
                    <div class="user">
                        <div class="top" v-if="user.user_profile">
                            <slot>{{user.user_profile.name}}</slot>
                        </div>
                        <div class="sub" v-if="user.user_role">{{user.user_role.name}}</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                    <span class="owner-tag" v-if="user.id === $store.state.user.user.id">you</span>
                </div>
            </div>
        </template>

        <template v-else-if="userGroup">
            <router-link class="user-wrap link" :to="`/users/user-groups/${userGroup.id}/details`"
                         v-if="$user.hasPermission('user-group-view')">
                <div class="user-inner">
                    <div class="user">
                        <div class="top">
                            <slot>{{userGroup.name}}</slot>
                        </div>
                        <div class="sub">user group</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                    <span class="owner-tag" v-if="memberCount && userGroup.members_count ">{{userGroup.members_count}} member<span
                            v-if="userGroup.members_count !== 1">s</span></span>
                </div>
            </router-link>
            <div class="user-wrap" v-else>
                <div class="user-inner">
                    <div class="user">
                        <div class="top">
                            <slot>{{userGroup.name}}</slot>
                        </div>
                        <div class="sub">user group</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                    <span class="owner-tag" v-if="memberCount && userGroup.members_count ">{{userGroup.members_count}} member<span
                            v-if="userGroup.members_count !== 1">s</span></span>
                </div>
            </div>
        </template>

        <template v-if="cm">
            <router-link class="user-wrap link" :to="`/content-managers/${cm.id}/details`"
                         v-if="cm.permissions && cm.permissions.includes('view')">
                <div class="user-inner">
                    <div class="user">
                        <div class="top">
                            <slot>{{cm.name}}</slot>
                        </div>
                        <div class="sub">content manager</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                </div>
            </router-link>
            <div class="user-wrap" v-else>
                <div class="user-inner">
                    <div class="user">
                        <div class="top">
                            <slot>{{cm.name}}</slot>
                        </div>
                        <div class="sub">content manager</div>
                    </div>
                    <span class="owner-tag" v-if="owner === 1">owner</span>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
  export default {

    name: "sc-table-user",
    props: {
      user: {},
      userGroup: {},
      cm: {},
      owner: {},
      memberCount: {
        type: Boolean,
        default: true,
      }
    },
  }
</script>

<style scoped lang="scss">
    .user-wrap {
        width: 100%;
        position: relative;
        display: block;
    }

    .user-wrap.link:after {
        transition-property: box-shadow, border, background;
        transition-duration: .15s;
        transition-timing-function: ease-in-out;
        cursor: pointer;
        content: '';
        position: absolute;
        left: -1em;
        right: -1em;
        top: -0.8em;
        bottom: -0.8em;
        border-radius: 0.3em;
        z-index: 1;
        background: transparent;
    }

    .user-wrap.link:hover:after {
        border: 1px solid #bbb;
        background: #fafafa;
    }

    .theme--dark .user-wrap:hover:after {
        background: #333;
        border: 1px solid transparent;
    }

    .user-inner {
        display: flex;
        align-items: center;
        position: relative;
        z-index: 2;
        pointer-events: none;
    }

    .top {
        font-weight: 500;
        /*font-size: 0.9em;*/
        margin-right: 10px;

    }

    .sub {
        font-weight: 700;
        font-size: 0.8em;
        margin-top: 0.3em;
        margin-right: 10px;
    }

    .owner-tag {
        /*margin-left: 10px;*/
    }

    .owner-tag:last-child {
        margin: 0;
    }
</style>